module.exports = __webpack_public_path__ + "static/media/Logo.42cab97d.png";